import type { CSSProperties, JSX } from 'react';
import accessRestrictedSvg from '../assets/images/error/error-access.svg';

/**
 * Decorative "access restricted" illustration for 403 failures. Loaded via
 * <img> (not inlined as JSX) since its colors are literal hex, not
 * `currentColor`/CSS custom properties — nothing here needs the host page's
 * styles to resolve.
 */
export function AccessRestrictedIllustration({
  className,
  style,
}: {
  readonly className?: string;
  readonly style?: CSSProperties;
}): JSX.Element {
  return <img alt="" aria-hidden="true" className={className} src={accessRestrictedSvg} style={style} />;
}
